import { z } from 'zod';
export const LineInboxStatusSchema = z.enum([
    'RECEIVED',
    'PROCESSED',
    'PARTIAL',
    'QUARANTINED',
    'FAILED',
    'SKIPPED',
]);
export const LineChannelCreateSchema = z.object({
    destination: z.string().min(1),
    channelSecret: z.string().min(1),
    channelAccessToken: z.string().min(1),
    active: z.boolean().optional(),
});
export const LineSenderAllowlistCreateSchema = z.object({
    lineUserId: z.string().min(1),
    note: z.string().optional(),
});
export const LineIntakeStatusSchema = z.object({
    enabled: z.boolean(),
    channelCount: z.number().int(),
    lastEventAt: z.string().nullable(),
    lastError: z.string().nullable(),
});
//# sourceMappingURL=line-intake.js.map